import React from "react";
import { Link } from "react-router-dom";
import { BsChatLeftHeart } from "react-icons/bs";
import "./PendingTributesBanner.css";

function PendingTributesBanner({
  count,
  preview,
  memorialName,
  reviewUrl,
  onReview,
  showViewAll,
  viewAllUrl,
}) {
  if (!count || count <= 0) return null;

  const ReviewAction = onReview ? "button" : Link;
  const reviewProps = onReview
    ? { type: "button", onClick: onReview }
    : { to: reviewUrl };

  return (
    <aside className="pending-tributes-banner" role="status" aria-live="polite">
      <div className="pending-tributes-banner-icon">
        <BsChatLeftHeart />
      </div>
      <div className="pending-tributes-banner-body">
        <p className="pending-tributes-banner-title">
          {count === 1
            ? "1 tribute awaiting your review"
            : `${count} tributes awaiting your review`}
        </p>
        {memorialName && (
          <p className="pending-tributes-banner-memorial">{memorialName}</p>
        )}
        {preview && <p className="pending-tributes-banner-preview">&ldquo;{preview}&rdquo;</p>}
        <div className="pending-tributes-banner-actions">
          <ReviewAction className="pending-tributes-banner-btn primary" {...reviewProps}>
            Review now
          </ReviewAction>
          {showViewAll && viewAllUrl && (
            <Link className="pending-tributes-banner-btn secondary" to={viewAllUrl}>
              View all memorials
            </Link>
          )}
        </div>
      </div>
    </aside>
  );
}

export default PendingTributesBanner;
